<template>
    <div>
        <v-layout row>
            <v-flex xs11 offset-xs1>
              <div class="submitbloc">
                  <span class="info-title">{{title}}</span>
              </div>
            </v-flex>
        </v-layout>
        <v-layout row class="submitform">
            <v-flex xs11 offset-xs1>

                <div>
                     <v-text-field v-model="contact.firstName" :label="$t('Claim.RequestClaim.FIRST_NAME_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.FIRST_NAME_PLACEHOLDER')" clearable></v-text-field>
                </div>
                <div>
                     <v-text-field v-model="contact.lastName" :label="$t('Claim.RequestClaim.LAST_NAME_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.LAST_NAME_PLACEHOLDER')" clearable></v-text-field>
                </div>
                <div>
                      <v-text-field v-model="contact.email" :rules="emailRules" :label="$t('Claim.RequestClaim.MAIL_ADDRESS_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.MAIL_ADDRESS_PLACEHOLDER')" clearable></v-text-field>
                </div>
                <div>
                      <v-text-field v-model="contact.mobilePhone" :rules="phoneRules" :label="$t('Claim.RequestClaim.MOBILE_NUMBER_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.MOBILE_NUMBER_PLACEHOLDER')" clearable></v-text-field>
                </div>
                <div>
                      <v-text-field v-model="contact.officePhone" :rules="phoneRules" :label="$t('Claim.RequestClaim.OFFICE_NUMBER_FIELD_NAME')" :placeholder="$t('Claim.RequestClaim.OFFICE_NUMBER_PLACEHOLDER')" clearable></v-text-field>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
  props: ['contact', 'title'],
  data () {
    return {
      phoneRules: [
        v => !v || /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(v) || 'Phone number must be valid'
      ],
      emailRules: [
        v => !v || /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  }
}
</script>
